import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { OptimizelyFeature } from '@optimizely/react-sdk';
import { FeatureToggleContext } from 'shell/utils/toggles';

/**
 * Component wrapper for <OptimizelyFeature />
 * See details there https://github.com/optimizely/react-sdk#optimizelyfeature
 * @param feature
 * @param children
 * @returns {*}
 * @constructor
 */
export const FeatureToggle = ({ feature, children }) => {
  const toggles = useContext(FeatureToggleContext);
  const localToggle = toggles?.[feature];

  if (typeof localToggle === 'undefined') {
    return <OptimizelyFeature feature={feature}>{children}</OptimizelyFeature>;
  }

  return children(localToggle);
};

FeatureToggle.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

export default FeatureToggle;
